import { atom, useAtom } from 'jotai';

export const loadingAtom = atom(false);

export type LoadingHandlerFn = (fn: () => Promise<void> | void) => Promise<void>;

export const useLoadingAtom = () => {
  const [isLoading, setIsLoading] = useAtom(loadingAtom);

  const handleLoading: LoadingHandlerFn = async fn => {
    setIsLoading(true);
    try {
      await fn();
    } catch {
      // ignore
    }
    setIsLoading(false);
  };

  return {
    isLoading,
    handleLoading,
  };
};
